import { getApiBaseUrl } from '../constant';

let lastProbeAt = 0;
let lastProbeResult = true;
const PROBE_TTL_MS = 8000;

/**
 * Device may be online while the API is unreachable (server down, DNS, TLS, etc.).
 * A short session probe distinguishes the two for offline-login fallback.
 */
export async function probeServerReachable(
	timeoutMs = 5000,
	force = false
): Promise<boolean> {
	const now = Date.now();
	if (!force && now - lastProbeAt < PROBE_TTL_MS) {
		return lastProbeResult;
	}

	try {
		const baseUrl = await getApiBaseUrl();
		const controller = new AbortController();
		const timer = setTimeout(() => controller.abort(), timeoutMs);

		const response = await fetch(`${baseUrl}/session/`, {
			method: 'POST',
			credentials: 'include',
			signal: controller.signal,
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});

		clearTimeout(timer);
		// Any HTTP response means the host answered (401/403 still reachable).
		lastProbeResult = response.status > 0 && response.status < 502;
	} catch {
		lastProbeResult = false;
	}

	lastProbeAt = now;
	return lastProbeResult;
}

export const isLikelyServerUnreachableError = (error: any): boolean => {
	const code = error?.code;
	const message = String(error?.message || '').toLowerCase();
	const status = error?.response?.status;

	if (status === 502 || status === 503 || status === 504) return true;
	if (code === 'ECONNABORTED' || code === 'ERR_NETWORK') return true;
	if (message.includes('network error') || message.includes('timeout')) {
		return true;
	}
	return false;
};
